const KEY_HAS_UNSAVED_WEEK_DRAFT = 'PLANNING_HAS_UNSAVED_WEEK_DRAFT'

export const setHasUnsavedWeekDraft = (hasUnsavedDraft) => {
  if (hasUnsavedDraft) {
    localStorage.setItem(KEY_HAS_UNSAVED_WEEK_DRAFT, 'true')
  } else {
    localStorage.removeItem(KEY_HAS_UNSAVED_WEEK_DRAFT)
  }
}

export const hasUnsavedWeekDraft = () => {
  return localStorage.getItem(KEY_HAS_UNSAVED_WEEK_DRAFT) === 'true'
}
